import React, { useEffect, useState } from 'react';
import { string } from 'prop-types';
import moment from "moment";
import 'moment-timezone';
import 'moment-duration-format';
import './Timer.scss'

const oneMinute = 60 * 1000

const Timer = ({ endTime: propEndTime }) => {
  const [timer, setTimer] = useState('')

  const [rawMinutes, rawHours, rawDays] = timer ? timer.split(':').reverse() : ['00', '00', '00']
  const [days, hours, minutes] = rawDays > 99 ? ['99', '99', '99'] : [rawDays, rawHours, rawMinutes]

  const descriptors = [
    { label: 'DAYS', slots: days || '00' },
    { label: 'HOURS', slots: hours || '00' },
    { label: 'MINUTES', slots: minutes || '00' },
  ]

  useEffect(() => {
    const timeLeft = moment(propEndTime).diff(moment(), "minutes");

    if (timeLeft > 0) {
      // eslint-disable-next-line
      const intervalId = useInterval(handleInterval, oneMinute, timeLeft * oneMinute)
      handleInterval()
      return () => clearInterval(intervalId)
    }
    else {
      setTimer(null)
    }

    // eslint-disable-next-line
  }, [propEndTime])


  const handleInterval = () => {
    if (!propEndTime) return

    const timeLeft = moment(propEndTime).diff(moment(), "minutes");
    if (timeLeft <= 0) {
      setTimer(null)
    } else {
      const updatedTimer = moment.duration(timeLeft, "minutes").format("DD:HH:mm")
      setTimer(updatedTimer)
    }
  };

  return (
    <div className="timer">
      {descriptors.map(({ label, slots }) => (
        <TimeSlot key={label + slots} label={label} slots={slots} />
      ))}
    </div>
  )
}

const useInterval = (handleInterval, interval, terminateAfter) => {
  const intervalId = setInterval(handleInterval, interval)
  setTimeout(() => {
    clearInterval(intervalId)
  }, terminateAfter);
  return intervalId
}

export const TimeSlot = ({ label, slots }) => {
  const [firstDigit, secondDigit] = slots;

  return (
    <div className="timer-timeslot">
      <div className="timer-timeslot__digits">
        {firstDigit && <Digit text={firstDigit} />}
        {secondDigit && <Digit text={secondDigit} />}
      </div>
      <div className="timer-timeslot__label">{label}</div>
    </div>
  );;
};

const Digit = ({ text }) => {
  return <div className="digit">{text}</div>;
};

Timer.propTypes = {
  endTime: string,
};

Timer.defaultProps = {
  endTime: '',
};

export default Timer
